export const progressnotesMetaFields = [
     
    {
        name: `Doctor`,
        field: `doctorId`,
        check: `required`,
    },
     
]; 